/**
 * bulge-premium-micro.js — magnetic primary CTAs (desktop) + optional word reveals.
 * Requires html[data-bulge-engine="on"]. Respects prefers-reduced-motion.
 */
(function () {
  if (!document.documentElement.hasAttribute('data-bulge-engine')) return;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var mq = window.matchMedia('(min-width: 990px)');

  function initMagnetic() {
    if (reduceMotion) return;
    if (!mq.matches) return;

    var sel =
      'main a.bulge-cta--primary, main button.bulge-cta--primary, main a.button.button--primary, main button.button.button--primary';
    var nodes = document.querySelectorAll(sel);

    nodes.forEach(function (el) {
      if (el.closest('[data-bulge-cart-drawer]')) return;
      if (el.hasAttribute('data-bulge-magnetic')) return;
      el.setAttribute('data-bulge-magnetic', '');

      function onMove(e) {
        var rect = el.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var dx = (e.clientX - cx) / (rect.width / 2);
        var dy = (e.clientY - cy) / (rect.height / 2);
        var cap = 10;
        el.style.setProperty('--bm-x', Math.max(-cap, Math.min(cap, dx * 6)) + 'px');
        el.style.setProperty('--bm-y', Math.max(-cap, Math.min(cap, dy * 6)) + 'px');
      }

      function reset() {
        el.style.setProperty('--bm-x', '0px');
        el.style.setProperty('--bm-y', '0px');
      }

      el.addEventListener('mousemove', onMove);
      el.addEventListener('mouseleave', reset);
      el.addEventListener('blur', reset);
    });
  }

  function escWord(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function splitWords(el) {
    if (el.dataset.bulgeRevealDone) return;
    var text = el.textContent.trim();
    if (!text) return;
    var words = text.split(/\s+/);
    if (words.length > 28) return;
    el.dataset.bulgeRevealDone = '1';
    el.innerHTML = words
      .map(function (w, i) {
        return (
          '<span class="bulge-reveal-w" style="--br-i:' +
          i +
          '">' +
          escWord(w) +
          '</span>'
        );
      })
      .join(' ');
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.bulge-reveal-words');
    if (!nodes.length) return;

    if (reduceMotion) {
      nodes.forEach(function (el) {
        splitWords(el);
        el.classList.add('is-inview');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        splitWords(el);
        el.classList.add('is-inview');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          splitWords(el);
          requestAnimationFrame(function () {
            el.classList.add('is-inview');
          });
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
    );

    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  function run() {
    initMagnetic();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  mq.addEventListener('change', function () {
    if (mq.matches) initMagnetic();
  });
})();
